import { getLessonSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy lesson-detail URL. Redirects to `/programs/{program}/{module}/{lesson}`.
 * Lessons under a single-lesson space have no module slug — those stay on the
 * legacy single-lesson route.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/modules/$moduleId/lessons/$lessonId/')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getLessonSlugPathQueryOptions(params.lessonId));
    if (!path.moduleSlug) {
      throw redirect({ to: '/community-hub/spaces/$id/lesson', params: { id: params.id }, replace: true });
    }
    throw redirect({
      to: '/programs/$programSlug/$moduleSlug/$lessonSlug',
      params: {
        programSlug: path.programSlug,
        moduleSlug: path.moduleSlug,
        lessonSlug: path.lessonSlug ?? '',
      },
      replace: true,
    });
  },
});
